export const appLogo = theme => ({
  root: {
    backgroundColor: theme.variables.colors.sidebarHeaderBg,
    minHeight: '64px',
  },
})
